import { request } from '../../services';
import { getPhaseFilters, getPhaseFiltersQueryOnly, getPhaseNextPage } from '../../reducers';
import {
  userUpdatePreferences,
  requestSavedFilters,
  requestAssignedFilters,
} from 'actionCreators';
import { createActions, createAction } from 'redux-actions';

const { phaseListSuccess, phaseListFailure, phaseListRequest } = createActions(
  {
    PHASE_LIST_SUCCESS: [json => json.phases, json => json.meta],
  },
  'PHASE_LIST_REQUEST',
  'PHASE_LIST_FAILURE',
);

const { exportPhasesSuccess, exportPhasesFailure } = createActions(
  {
    EXPORT_PHASES_SUCCESS: [json => json.phases, json => json.meta],
  },
  'EXPORT_PHASES_FAILURE',
);

export const requestPhaseList = (ignoreLocationFilters = false) => (dispatch, getState) => {
  const state = getState();
  const page = getPhaseNextPage(state);
  const filterParams = ignoreLocationFilters
    ? getPhaseFiltersQueryOnly(state)
    : getPhaseFilters(state);
  if (page === null || page === undefined) {
    return Promise.resolve('');
  }
  dispatch(phaseListRequest());
  return request(`phases?page=${page}&${filterParams}`)
    .then(({ json }) => dispatch(phaseListSuccess(json)))
    .catch(error => dispatch(phaseListFailure(error)));
};

export const requestPhasesForExport = page => (dispatch, getState) => {
  const state = getState();
  const filterParams = getPhaseFilters(state);
  return request(`phases/phase_export?page=${page}&limit=1000&${filterParams}`)
    .then(({ json }) => dispatch(exportPhasesSuccess(json)))
    .catch(error => dispatch(exportPhasesFailure(error)));
};

export function resetPhasePagination(filter) {
  return dispatch =>
    Promise.all([
      dispatch({ type: 'PHASE_SET_FILTER', payload: filter }),
      dispatch({ type: 'PHASE_RESET_PAGINATION' }),
    ]);
}
const updatePhaseFiltersLocationRequest = createAction('UPDATE_PHASE_FILTERS_LOCATION_REQUEST');

export const updatePhaseFiltersLocation = filters => dispatch =>
  Promise.all([
    dispatch(userUpdatePreferences({ saved_location_filters: filters })),
    dispatch(updatePhaseFiltersLocationRequest(filters)),
    dispatch({ type: 'PHASE_RESET_PAGINATION' }),
    dispatch(requestPhaseList()),
  ]).then(() => dispatch(requestSavedFilters()))
    .then(() => dispatch(requestAssignedFilters()));



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/phases.js